import React, { useContext, useEffect, useState } from 'react';

import cx from 'classnames';
import { useTrackersDefaultCurriculumData } from 'sdk';

import MathAssignmentCreateFlow from 'pages/Teachers/Assignments/MathAssignmentCreateFlow';
import { useMixpanelPageOpenTrack } from 'utils/integrations/mixpanel';
import { trackMixpanelPageView } from 'utils/integrations/mixpanel';

import AcceleratedCurriculumSwitch from './components/AcceleratedCurriculumSwitch';
import AssignmentCreateSelectFlow from './components/AssignmentCreateSelectFlow';
import SubjectSelect from './components/SubjectSelect';
import CurriculumIndex from 'components/CurriculumIndex';
import UserContext from 'components/UserContext';

import styles from './styles.module.scss';

const CREATE_ASSIGNMENT_NEW_FLOW_ENABLED =
  process.env.REACT_APP_CREATE_ASSIGNMENT_NEW_FLOW_ENABLED === 'true';

const TeacherAssignmentCreate = () => {
  const [isFlowSelected, setIsFlowSelected] = useState(false);
  const [selectedSubject, setSelectedSubject] = useState(null);
  const [isCreateTemplateSelected, setIsCreateTemplateSelected] =
    useState(false);

  const [isAcceleratedCurriculum, setIsAcceleratedCurriculum] = useState(false);

  const { user } = useContext(UserContext);

  const {
    data: trackersDefaultCurriculumData,
    isLoading: isLoadingDefaultData
  } = useTrackersDefaultCurriculumData();

  useEffect(() => {
    if (!trackersDefaultCurriculumData) return;

    if (trackersDefaultCurriculumData['is_accelerated'])
      setIsAcceleratedCurriculum(true);
    else setIsAcceleratedCurriculum(false);
  }, [trackersDefaultCurriculumData]);

  useEffect(() => {
    trackMixpanelPageView(user.id, {
      feature: 'create',
      view: 'type'
    });
  }, [user]);

  useMixpanelPageOpenTrack('Teacher opened Create page');

  const showStepper = selectedSubject !== null;

  return (
    <div
      className={cx(styles.container, {
        [styles.newFlowContainer]:
          CREATE_ASSIGNMENT_NEW_FLOW_ENABLED && selectedSubject
      })}
    >
      {isFlowSelected &&
        isCreateTemplateSelected &&
        CREATE_ASSIGNMENT_NEW_FLOW_ENABLED && (
          <div className={styles.buttonContainer}>
            <button
              type="button"
              className={styles.backButton}
              onClick={() => {
                setIsFlowSelected(false);
                setIsCreateTemplateSelected(false);
              }}
            >
              ← BACK: CHOOSE TYPE
            </button>
          </div>
        )}

      {showStepper && !CREATE_ASSIGNMENT_NEW_FLOW_ENABLED && (
        <div className={styles.navTabs}>
          <button type="button" className={`${styles.tab} ${styles.active}`}>
            Choose type
          </button>
          <button
            type="button"
            className={`${styles.tab} ${styles.tabProgress}`}
          >
            Create
          </button>
          {selectedSubject === 'math' && !isCreateTemplateSelected && (
            <button
              type="button"
              className={`${styles.tab} ${styles.tabProgress}`}
            >
              Confirm
            </button>
          )}
          <button
            type="button"
            className={`${styles.tab} ${styles.tabProgress}`}
          >
            Assign
          </button>
        </div>
      )}

      {!selectedSubject && <SubjectSelect selectSubject={setSelectedSubject} />}

      {/* TODO: Add actions onSuccess and onClose */}
      {!isFlowSelected &&
        selectedSubject &&
        (CREATE_ASSIGNMENT_NEW_FLOW_ENABLED && selectedSubject === 'math' ? (
          <MathAssignmentCreateFlow
            onAssignSuccess={() => {}}
            onClose={() => {}}
          />
        ) : (
          <AssignmentCreateSelectFlow
            setIsFlowSelected={setIsFlowSelected}
            setIsCreateTemplateSelected={setIsCreateTemplateSelected}
            isMathAssignment={
              selectedSubject === 'math' || selectedSubject === null
            }
          />
        ))}

      {isFlowSelected && isCreateTemplateSelected && (
        <>
          <AcceleratedCurriculumSwitch
            isAcceleratedCurriculum={isAcceleratedCurriculum}
            setIsAcceleratedCurriculum={setIsAcceleratedCurriculum}
          />
          <CurriculumIndex
            isAcceleratedCurriculum={isAcceleratedCurriculum}
            defaultData={trackersDefaultCurriculumData}
            isLoadingDefaultData={isLoadingDefaultData}
          />
        </>
      )}
    </div>
  );
};

export default TeacherAssignmentCreate;
